import {
  FiltersCutEditorModalController
} from './filters-cut-editor-modal.component';

export class FiltersCutEditorModalService {
  constructor($timeout, $modal) {
    this.$timeout = $timeout;
    this.$modal = $modal;
  }

  open(cut, filterService, asNew) {
    const updateModalSize = () => {
      $('.modal-body1').height((window.innerHeight * 0.96 -
        $('.modal-header').outerHeight() -
        $('.col-headers').outerHeight() -
        $('.modal-footer').outerHeight() ));
        document.querySelector('.search-name input').focus();
    };

    this.modalInstance = this.$modal.open({
      template: require('./filters-cut-editor-modal.component.html'),
      controller: FiltersCutEditorModalController,
      resolve: {
        asNew: () => asNew,
        cut: () => cut,
      },
      windowClass: 'sc-filters-cut-editor-modal',
    });
    this.modalInstance.opened
      .then(() => {
        this.$timeout(() => {
          updateModalSize();
        }, 100);
      })
      .catch((err) => {
        console.error(err);
      });
    return this.modalInstance.result;
  }
}



// WEBPACK FOOTER //
// ./src/filter/editor/cut-editor/filters-cut-editor-modal.service.js